import { type SeverityType } from '~/components/SnackbarAlert/types';

import { ActionKeys } from './constants';

interface AddSnackbarMessagePayload {
  i18n?: boolean;
  i18nValues?: Record<string, unknown>;
  message: string;
  severity: SeverityType;
}

export const addSnackbarMessage = (payload: AddSnackbarMessagePayload) =>
  <const>{
    payload: {
      i18n: payload.i18n || false,
      i18nValues: payload.i18nValues,
      message: payload.message,
      severity: payload.severity,
    },
    type: ActionKeys.SNACKBAR_ADD_MESSAGE,
  };

export type SnackbarActions = ReturnType<typeof addSnackbarMessage>;
